<script setup>
import { ref, computed, onBeforeUnmount, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useGroupsAttrsStore } from '@/stores/groups-attrs'
import { useUserCarsStore } from '@/stores/user-cars'

function changePage(cursor, dir) {

    const params = {
        'c.limit': 6, 
        'c.direction': dir, 
        'c.cursor': cursor
    }

    userCarsStore.readUserCarsCreateList(params).then(result => {
        if(result.array) {
            dir == 'after' ? 
                pageNumber.value++ : 
                pageNumber.value--
        }
    })
}

function showAttributes(event) {
    event.currentTarget.parentElement.classList.toggle('attrs-shown')
}

function submitForm(event) {

    const fields = event.target.getElementsByTagName("input")

    let data = {
        attr: {
            array: []
        },
        user: fields.user.value,
        car: fields.car.value
    }

    for(let field of fields) {
        if(field.type == 'checkbox' && field.checked) {
            if(field.name == 'navi')        data.attr.array.push(...attrsNavi.value)
            if(field.name == 'remote')      data.attr.array.push(...attrsRemote.value)
            if(field.name == 'diagnostic')  data.attr.array.push(...attrsDiagnostic.value)
            if(field.name == 'developer')   data.attr.array.push(...attrsDeveloper.value)
        }
    }

    userCarsStore.createUserCars(data)
}

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const translaterStore   = useTranslaterStore()
const groupsAttrsStore  = useGroupsAttrsStore()
const userCarsStore     = useUserCarsStore()

const getTranslate              = computed(() => translaterStore.getTranslate)
const attrsNavi                 = computed(() => groupsAttrsStore.navi)
const attrsRemote               = computed(() => groupsAttrsStore.remote)
const attrsDiagnostic           = computed(() => groupsAttrsStore.diagnostic)
const attrsDeveloper            = computed(() => groupsAttrsStore.developer)
const userCarsCreateList        = computed(() => userCarsStore.userCarsCreateList)
const userCarsCreateListProcess = computed(() => userCarsStore.userCarsCreateListProcess)
const userCarsCreateListMsg     = computed(() => userCarsStore.userCarsCreateListMsg)
const userCarsCreateProcess     = computed(() => userCarsStore.userCarsCreateProcess)
const userCarsCreateMsg         = computed(() => userCarsStore.userCarsCreateMsg)

const inputSearch = ref('')
const pageNumber = ref(1)

userCarsStore.readUserCarsCreateList({ 'c.limit': 6 })

onBeforeUnmount(() => {

    userCarsStore.setUserCarsCreateMsg({})
})

watch(inputSearch, input => {
    input.length > 2 ? 
        userCarsStore.readUserCarsCreateList({ 'c.limit': 6, 'c.q': inputSearch.value }) :
        userCarsStore.readUserCarsCreateList({ 'c.limit': 6 })
})
</script>

<template>
    <div class="uta-user-cars-create">

        <div class="row mb-4 justify-content-between">
            <div class="col-12">
                <div class="uta-input__wrapper uta-search">
                    <input 
                        type="text" 
                        :placeholder="getTranslate.SEARCH + '...'" 
                        v-model="inputSearch"
                        @keyup.escape="inputSearch = ''"
                        class="form-control uta-input__wrapper-input uta-search__input uta-search__input--light" 
                    >
                    <template v-if="inputSearch.length > 2">
                        <span class="material-icons uta-input__wrapper-icon" @click="inputSearch = ''">
                            cancel
                        </span>
                    </template>
                    <template v-else>
                        <span class="material-icons uta-input__wrapper-icon">
                            search
                        </span>
                    </template>
                </div>
            </div>
        </div>

        <div 
            v-if="
                'success' in userCarsCreateListMsg && 
                !userCarsCreateListMsg.success
            "
            class="my-4 uta-alert uta-alert--success"
        >
            <span class="material-icons uta-alert__icon">check_circle_outline</span>
            <div class="uta-alert__text">
                {{ getTranslate[userCarsCreateListMsg.text] || userCarsCreateListMsg.text }}
            </div>
        </div>

        <div 
            v-if="'success' in userCarsCreateMsg"
            class="my-4 uta-alert"
            :class="{
                'uta-alert--success' : userCarsCreateMsg.success, 
                'uta-alert--danger' : !userCarsCreateMsg.success
            }"
        >
            <span class="material-icons uta-alert__icon">
                {{ userCarsCreateMsg.success ? 'check_circle_outline' : 'error_outline' }}
            </span>
            <div class="uta-alert__text">
                {{ getTranslate[userCarsCreateMsg.text] || userCarsCreateMsg.text }}
            </div>
            <button type="button" class="uta-alert__close" @click="userCarsStore.setUserCarsCreateMsg({})">
                <span class="material-icons">close</span>
            </button>
        </div>

        <div v-if="userCarsCreateList.array?.length">

            <div class="mb-4 uta-list uta-user-cars-create__list">
                <div class="uta-list__title d-none d-md-block uta-cars__title">
                    <div class="row">
                        <div class="col-md-5">{{ getTranslate.CARS_IMEI }}</div>
                        <div class="col-md-5">{{ getTranslate.CARS_VIN }}</div>
                    </div>
                </div>
                <div class="uta-list__content">
                    <form
                        action="" 
                        class="uta-user-cars-create__item align-items-center uta-list__item row"
                        v-for="(car, index) in userCarsCreateList.array"
                        :key="index"
                        @submit.prevent="submitForm($event)" 
                    >
                        <div class="col-10 col-md-5 uta-user-cars-create__name" @click="showAttributes($event)">
                            <span class="d-inline d-md-none">{{ getTranslate.CARS_IMEI }}: </span>
                            <a href="#" class="uta-list__item-link uta-user-cars-create__name">
                                {{ car.data?.imei }}
                            </a>
                        </div>
                        <div class="col-10 col-md-5 mt-3 mt-md-0 uta-user-cars-create__name" @click="showAttributes($event)">
                            <span class="d-inline d-md-none">{{ getTranslate.CARS_VIN }}: </span>
                            {{ car.data?.vin }}
                        </div>
                        <div class="col-2 text-end uta-user-cars-create__attrs-ctrl" @click="showAttributes($event)">
                            <span class="material-icons">
                                expand_more
                            </span>
                        </div>
                        <div class="col-24 pt-3 uta-user-cars-create__attrs">

                            <!-- Навигационная информация -->
                            <div class="form-check">
                                <input 
                                    type="checkbox" 
                                    name="navi"
                                    class="form-check-input uta-users-group-cars__attrs-attr" 
                                    :id="'users-group-cars-attr_navi-' + car.uuid"
                                > 
                                <label 
                                    class="form-check-label" 
                                    :for="'users-group-cars-attr_navi-' + car.uuid"
                                >
                                    {{ getTranslate.ATTR_GEODATA }}
                                </label>
                            </div>

                            <!-- Удаленное управление -->
                            <div class="form-check">
                                <input 
                                    type="checkbox" 
                                    name="remote"
                                    class="form-check-input uta-users-group-cars__attrs-attr" 
                                    :id="'users-group-cars-attr_remote-' + car.uuid"
                                > 
                                <label 
                                    class="form-check-label" 
                                    :for="'users-group-cars-attr_remote-' + car.uuid"
                                >
                                    {{ getTranslate.ATTR_REMOTE_CONTROL }}
                                </label>
                            </div>

                            <!-- Диагностика -->
                            <div class="form-check">
                                <input 
                                    type="checkbox" 
                                    name="diagnostic"
                                    class="form-check-input uta-users-group-cars__attrs-attr" 
                                    :id="'users-group-cars-attr_diagnostic-' + car.uuid"
                                > 
                                <label 
                                    class="form-check-label" 
                                    :for="'users-group-cars-attr_diagnostic-' + car.uuid"
                                >
                                    {{ getTranslate.ATTR_DIAGNOSTIC }}
                                </label>
                            </div>

                            <!-- Режим разработчика -->
                            <div class="form-check">
                                <input 
                                    type="checkbox" 
                                    name="developer"
                                    class="form-check-input uta-users-group-cars__attrs-attr" 
                                    :id="'users-group-cars-attr_developer-' + car.uuid"
                                > 
                                <label 
                                    class="form-check-label" 
                                    :for="'users-group-cars-attr_developer-' + car.uuid"
                                >
                                    {{ getTranslate.ATTRS_DEVELOPER }}
                                </label>
                            </div>

                            <button type="submit" :disabled="userCarsCreateProcess" class="uta-btn uta-btn--main mt-3">
                                <template v-if="!userCarsCreateProcess">
                                    {{ getTranslate.BTN_ADD }}
                                </template>
                                <template v-else>
                                    <div class="spinner-border" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </template>
                            </button>
                        </div>
                        <input type="hidden" name="car" :value="car.uuid">
                        <input type="hidden" name="user" :value="props.uuid">
                    </form>
                </div>
            </div>

            <div class="uta-cars__pagination" v-if="userCarsCreateList.c && (userCarsCreateList.c.isBefore || userCarsCreateList.c.isAfter)">
                <div class="row">
                    <div class="col-12 col-xs-6 col-sm-6 col-md-4 col-xl-3">
                        <div class="uta-pagination">
                            <button 
                                :disabled="userCarsCreateListProcess || !userCarsCreateList.c.isBefore"
                                class="uta-btn uta-btn--sm uta-pagination__prev" 
                                @click.prevent="changePage(userCarsCreateList.c.start, 'before')"
                            >
                                <span class="material-icons">
                                    navigate_before
                                </span>
                            </button>
                            <div class="uta-pagination__current">
                                {{ pageNumber }}
                            </div>
                            <button 
                                :disabled="userCarsCreateListProcess || !userCarsCreateList.c.isAfter"
                                class="uta-btn uta-btn--sm uta-pagination__next" 
                                @click.prevent="changePage(userCarsCreateList.c.stop, 'after')"
                            >
                                <span class="material-icons">
                                    navigate_next
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/user/user-cars-create';
</style>